import React from 'react/addons';
import cx from 'classnames';


var Row = React.createClass({
  render () {
    var classes = cx({
      'ofs-Grid': true
    });

    return (
      <div className={classes}>
        {this.props.children}
      </div>
    );
  }
});

export default Row;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/forms/layout/row.jsx
 **/